/**
 * blueConfig.js
 * -----------------------------------------------------------
 * Configuration centrale du module Blue.
 *
 * L'application hôte peut surcharger n'importe quelle valeur en
 * passant un objet `config` au composant racine <BlueAssistant/>.
 *
 * Phase E2 (2026-09-21) — UI simplifiée : `showTagline: false` et
 * `suggestions: []` par défaut. Les 6 langues publiques sont
 * localisées depuis l'hôte via `strings` + `greeting` + `tagline`.
 * -----------------------------------------------------------
 */

export const defaultBlueConfig = {
  // Identité
  name: "Blue",
  role: "mascotte et guide",
  tagline: "",
  greeting:
    "Bonjour, je suis Blue, votre guide ITERCATUS. Comment puis-je vous aider ?",

  // Phase E2 — bulle externe SUPPRIMÉE (`showTagline: false`) et suggestions
  // SUPPRIMÉES (`suggestions: []`) sur toute l'application publique.
  suggestions: [],

  // Comportement
  position: "bottom-right", // "bottom-right" | "bottom-left"
  openByDefault: false,
  showTagline: false,

  // Animation
  respectReducedMotion: true,
  pauseWhenHidden: true,

  // Provider IA (voir services/aiProvider.js)
  provider: "mock",
  httpEndpoint: null,
  httpHeaders: null,
  httpTimeoutMs: 25000,

  // Langue par défaut si absente du contexte.
  defaultLocale: "fr",

  // Limites
  maxHistoryLength: 60,
  historyWindowForProvider: 20,
  inputMaxLength: 500,

  // Textes UI (localisables — voir BlueBridge.jsx override via i18n).
  strings: {
    inputPlaceholder: "Écrivez à Blue…",
    sendLabel: "Envoyer",
    closeLabel: "Fermer",
    openLabel: "Ouvrir Blue",
    thinkingLabel: "Blue réfléchit…",
    onlineLabel: "En ligne",
    suggestionsLabel: "Suggestions pour démarrer",
    errorLabel:
      "Une gêne passagère empêche Blue de répondre. Merci de réessayer dans un instant.",
    emptyReplyLabel:
      "Blue n'a rien trouvé à répondre pour l'instant. Pouvez-vous reformuler votre question ?",
    aiDisclosureShort: "Blue utilise l'intelligence artificielle.",
    aiDisclosureFull:
      "Blue est l'assistant numérique d'ITERCATUS et utilise l'intelligence artificielle. " +
      "Ses réponses peuvent contenir des erreurs ou des informations incomplètes. Pour les " +
      "informations importantes, consultez les sources indiquées.",
    aiDisclosureMore: "En savoir plus",
    aiDisclosureLess: "Réduire",
  },
};

/** Fusionne une config utilisateur avec la config par défaut. */
export function resolveConfig(userConfig = {}) {
  const strings = { ...defaultBlueConfig.strings, ...(userConfig.strings || {}) };
  const merged = { ...defaultBlueConfig, ...userConfig, strings };
  if (merged.suggestions === null) merged.suggestions = [];
  return merged;
}
